const routes = [
  {
    path: '/ActiveHealth',
    redirect: { name: 'sign-in', params: { loginTo: 'ActiveHealth' }}
  },
  {
    path: '/HealthDistrict',
    redirect: { name: 'sign-in', params: { loginTo: 'HealthDistrict' }}
  },
  {
    path: '/ActiveHealth/sign-in',
    name: 'sign-in',
    component: () => import('../views/SignInView.vue'),
    beforeEnter: checkUserLogin,
  },
  // {
  //   path: '/ActiveHealth/sign-up',
  //   name: 'sign-up',
  //   component: () => import('../views/SignUpView.vue'),
  // },
  {
    path: '/ActiveHealth/introduction',
    name: 'intro-page',
    component: () => import('../views/IntroPageView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/safety-precautions',
    name: 'safety-precautions',
    component: () => import('../views/SafetyPrecautionsView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/workout',
    name: 'workout',
    component: () => import('../views/WorkoutView.vue'),
    props: route => ({ height: route.query.height}),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/workout/:mode',
    name: 'workout',
    component: () => import('../views/WorkoutView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/user-details',
    name: 'user-details',
    component: () => import('../views/UserDetailsView.vue'),
    props: route => ({ height: route.query.height}),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/score-board',
    name: 'score-board',
    component: () => import('../views/ScoreBoardView.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/leaderboard',
    name: 'leaderboard',
    component: () => import('../views/LeaderBoardView.vue'),
    beforeEnter: checkUserLogin,
  },
   {
    path: '/ActiveHealth/leaderboard/v2',
    name: 'leaderboard',
    component: () => import('../views/RankLeaderBoard.vue'),
    beforeEnter: checkUserLogin,
  },
  {
    path: '/ActiveHealth/info',
    name: 'info',
    component: () => import('../views/InfoView.vue'),
    beforeEnter: checkUserLogin,
  },
  // {
  //   path: '/ActiveHealth',
  //   redirect: (from) => {
  //     return { name: 'sign-in', params: { tenant: from.params.tenant }}
  //   }
  // },
]

function checkUserLogin(to, from, next) {
  const isAnonymous = localStorage.getItem('login') ? (JSON.parse(localStorage.getItem('login'))).isAnonymous : true;
  if (isAnonymous) {
    if (to.name == 'sign-in')
      next()
    else
      next({name: 'sign-in'});
  }
  else {
    if(to.name == 'sign-in'){
      next({name: 'intro-page'});
    }
    else{
      next();
    }
  }

}

export default routes
